import { render, staticRenderFns } from "./extra-style.vue?vue&type=template&id=58297f17&scoped=true&"
import script from "./extra-style.vue?vue&type=script&lang=js&"
export * from "./extra-style.vue?vue&type=script&lang=js&"
import style0 from "./extra-style.vue?vue&type=style&index=0&id=58297f17&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58297f17",
  null
  
)

export default component.exports